(() => {
 'use strict';


 const RULES = [
   {
     // Bundle product: IR SaunaPod
     bundleProductId: 9974503145788,


     // Products already included with this bundle
     includedProductIds: [
       9974739435836, // SaunaPod Chair
       9974739108156  // SaunaPod Cover
     ]
   }
 ];


 let bypassValidation = false;


 async function getCart() {
   const response = await fetch('/cart.js', {
     credentials: 'same-origin',
     headers: { Accept: 'application/json' }
   });


   if (!response.ok) throw new Error('Unable to fetch cart');


   return response.json();
 }


 function findConflict(cart) {
   if (!cart || !Array.isArray(cart.items)) return null;


   for (const rule of RULES) {
     const bundle = cart.items.find(
       item => Number(item.product_id) === Number(rule.bundleProductId)
     );


     if (!bundle) continue;


     const includedIds = rule.includedProductIds.map(Number);


     const extras = cart.items.filter(item =>
       includedIds.includes(Number(item.product_id))
     );


     if (extras.length > 0) {
       return { bundle, extras };
     }
   }


   return null;
 }


 function createPopup() {
   if (document.getElementById('bundle-popup')) return;


   const style = document.createElement('style');
   style.innerHTML = `
     #bundle-popup{display:none;position:fixed;inset:0;z-index:999999;font-family:inherit;}
     #bundle-popup.active{display:block;}
     #bundle-popup .overlay{position:absolute;inset:0;background:rgba(0,0,0,.45);}
     #bundle-popup .box{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);background:#fff;width:92%;max-width:460px;border-radius:16px;padding:34px 28px 28px;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.22);}
     #bundle-popup .bundle-close{position:absolute;top:12px;right:14px;border:none;background:transparent;font-size:26px;line-height:1;cursor:pointer;width:auto;padding:0;margin:0;}
     #bundle-popup .bundle-icon{width:42px;display:none;height:42px;margin:0 auto 16px;border-radius:50%;background:#2d5b5b;color:#fff;display:flex;align-items:center;justify-content:center;font-size:22px;font-weight:600;}
     #bundle-popup h2{margin:0 0 14px;font-size:22px;line-height:1.3;}
     #bundle-popup p{margin:0 0 22px;font-size:15px;line-height:1.6;}
     #bundle-popup ul{list-style:none;padding:0;margin:0 0 22px;}
     #bundle-popup li{margin:6px 0;font-size:15px;}
     #bundle-popup button{width:100%;padding:14px;margin-top:10px;cursor:pointer;border-radius:999px;font-size:15px;}
     #bundle-popup .primary{background:#2d5b5b;color:#fff;border:1px solid #2d5b5b;}
     #bundle-popup .secondary{background:#fff;color:#2d5b5b;border:1px solid #2d5b5b;}
   `;
   document.head.appendChild(style);


   const popup = document.createElement('div');
   popup.id = 'bundle-popup';
   popup.innerHTML = `
     <div class="overlay"></div>
     <div class="box" role="dialog" aria-modal="true">
       <button type="button" class="bundle-close" id="bundle-close" aria-label="Lukk">×</button>
       <div class="bundle-icon">✓</div>
       <h2>Dette tilbehøret er allerede inkludert</h2>
       <p id="bundle-message"></p>
       <ul id="bundle-extra-list"></ul>
       <button type="button" class="secondary" id="remove-extra">Fjern inkluderte produkter</button>
       <button type="button" class="primary" id="keep-both">Behold alle</button>
     </div>
   `;
   document.body.appendChild(popup);
 }


 async function removeCartItems(items) {
   for (const item of items) {
     await fetch('/cart/change.js', {
       method: 'POST',
       credentials: 'same-origin',
       headers: {
         'Content-Type': 'application/json',
         Accept: 'application/json'
       },
       body: JSON.stringify({
         id: item.key,
         quantity: 0
       })
     });
   }
 }


 function proceedToCheckout() {
   bypassValidation = true;
   window.location = '/checkout';
 }


 function openPopup(conflict) {
   createPopup();


   const popup = document.getElementById('bundle-popup');
   const list = document.getElementById('bundle-extra-list');


   document.getElementById('bundle-message').innerHTML =
     `<strong>${conflict.bundle.product_title}</strong> inkluderer allerede følgende produkter:`;


   list.innerHTML = conflict.extras
     .map(item => `<li>✓ ${item.product_title}</li>`)
     .join('');


   const removeText =
     conflict.extras.length === 1
       ? `Fjern ${conflict.extras[0].product_title}`
       : 'Fjern inkluderte produkter';


   document.getElementById('remove-extra').textContent = removeText;


   popup.classList.add('active');


   document.getElementById('bundle-close').onclick = () => {
     popup.classList.remove('active');
   };


   popup.querySelector('.overlay').onclick = () => {
     popup.classList.remove('active');
   };


   document.getElementById('keep-both').onclick = () => {
     proceedToCheckout();
   };


   document.getElementById('remove-extra').onclick = async () => {
     await removeCartItems(conflict.extras);
     proceedToCheckout();
   };
 }


 async function validateCheckout(event) {
   if (bypassValidation) return;


   const checkoutButton = event.target.closest(
     'button[name="checkout"], .cart__checkout, [href="/checkout"]'
   );


   if (!checkoutButton) return;


   event.preventDefault();
   event.stopImmediatePropagation();
   event.stopPropagation();


   try {
     const cart = await getCart();
     const conflict = findConflict(cart);


     if (!conflict) {
       proceedToCheckout();
       return;
     }


     openPopup(conflict);
   } catch (error) {
     console.warn('[Bundle Validator]', error);
     proceedToCheckout();
   }
 }


 document.addEventListener('click', validateCheckout, true);
})();
